import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { type TopicDto, updateTopic } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useUpdateTopic(): UseMutationResult<TopicDto, AxiosError, TopicDto> {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (topic) => updateTopic({ path: { id: topic.id }, body: topic }).then((result) => result.data!),
        onSuccess: (topic) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.fullTopics(topic.id) });
            queryClient.invalidateQueries({ queryKey: queryKeys.topics() });
            queryClient.invalidateQueries({ queryKey: queryKeys.topic() });
            showSuccessToast(t('successActionGeneric'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
}
